// Page visibility rules. Mirrors backend/pages.js (keys + routes); labels for
// the page-access selectors come from GET /api/pages.
// This is navigation only — the API still enforces roles on every request.

export const PAGE_ROUTES = {
  dashboard: '/',
  uptime:    '/uptime',
  dns:       '/dns',
  ssl:       '/ssl',
  reputation: '/reputation',
  ai:        '/ai',
  logs:      '/logs',
  users:     '/users',
};

// Pages a non-admin saw before per-user permissions existed. Used when a
// user's allowed_pages is null (account created before this feature).
// Newer pages (e.g. 'reputation') must be granted explicitly.
export const LEGACY_PAGES = ['dashboard', 'uptime', 'dns', 'ssl', 'ai', 'logs'];

export function canAccessPage(user, key) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  // Dashboard is always allowed so nobody is left without a landing page.
  if (key === 'dashboard') return true;
  const allowed = Array.isArray(user.allowed_pages) ? user.allowed_pages : LEGACY_PAGES;
  return allowed.includes(key);
}

// Where to send a user who opens a page they can't see.
export function firstAllowedRoute(user) {
  const key = Object.keys(PAGE_ROUTES).find(k => canAccessPage(user, k));
  return key ? PAGE_ROUTES[key] : '/';
}
